/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-13 13:59:09
 *
 *******************************************************/

import React, { Component } from 'react';
import { Icon } from '@shopify/polaris';
import { ArrowUpMinor, ArrowDownMinor } from '@shopify/polaris-icons';

import { formatNumberInThousand } from 'src/helpers';

type Props = {
  type: string,
  compare: boolean,
  listCollection: Array<Object>
};

class Percent extends Component<Props> {
  render() {
    const { percent } = this.props;

    const percentChange = {
      empty: <span className="percentChange">-</span>,
      up: (
        <React.Fragment>
          <Icon source={ArrowUpMinor} color="success" />
          {` ${formatNumberInThousand(percent)}%`}
        </React.Fragment>
      ),
      down: (
        <React.Fragment>
          <Icon source={ArrowDownMinor} color="critical" />
          {` ${formatNumberInThousand(Math.abs(percent))}%`}
        </React.Fragment>
      ),
      unchanged: <React.Fragment>{` 0%`}</React.Fragment>
    };

    const status =
      percent === null || percent === undefined
        ? 'empty'
        : percent > 0
        ? 'up'
        : percent < 0
        ? 'down'
        : 'unchanged';

    return percentChange[status];
  }
}

export default Percent;
